import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Overlay from './Overlay';
import { BASE_URL } from "../constants/config";

const getNewCourse = () => {
    return {
        id: '',
        name: 'Test',
        type: 'scorm12',
        file: null
    };
};

const Courses = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [courses, setCourses] = useState([]);
    const [newCourse, setNewCourse] = useState(getNewCourse());

    const courseTypes = ['scorm12', 'scorm2004', 'xapi'];

    useEffect(() => {
        fetchCourses();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewCourse(prevCourse => ({ ...prevCourse, [name]: value }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setNewCourse(prevCourse => ({ ...prevCourse, file }));
    };

    const handleAddCourse = async () => {
        setIsLoading(true);
        const formData = new FormData();
        formData.append('name', newCourse.name);
        formData.append('type', newCourse.type);
        formData.append('file', newCourse.file);

        try {
            // NOTE: May be we need to pass companyId and userId here.
            // So that we can POST the courses related to only for that company
            // And the user who is uploading/creating the course
            await axios.post(`${BASE_URL}/api/course`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            fetchCourses();
            setNewCourse(getNewCourse());
        } catch (error) {
            console.error('Error uploading file:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchCourses = async () => {
        try {
            // NOTE: May be we need to pass companyId and userId here so that we can only GET those courses which are related particular company.
            // And the user who is only allowed to see those courses.
            const response = await axios.get(`${BASE_URL}/api/course`);
            setCourses(response.data);
        } catch (error) {
            console.error('Failed to fetch courses:', error);
        }
    };

    const navigate = useNavigate();

    const viewCourse = (id) => {
        navigate(`/course/${id}`);
    };

    return (
        <div> {isLoading && <Overlay LoadingText="Uploading..." />}
            <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <div className="bg-white p-8 rounded-lg shadow-lg">
                    <h1 className="text-2xl font-bold mb-6 text-center">Course Management</h1>
                    <form className="space-y-4">
                        <div className="form-group">
                            <label htmlFor="type" className="block text-sm font-medium text-gray-700">Type:</label>
                            <select
                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                id="type"
                                name="type"
                                value={newCourse.type}
                                onChange={handleInputChange}
                            >
                                {courseTypes.map(type => (
                                    <option key={type} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="file" className="block text-sm font-medium text-gray-700">File:</label>
                            <input
                                type="file"
                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                id="file"
                                name="file"
                                onChange={handleFileChange}
                            />
                        </div>
                        <button
                            type="button"
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            onClick={handleAddCourse} disabled={isLoading}>
                            Add Course
                        </button>
                    </form>
                    <table className="mt-6 min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    ID
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Name
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Type
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {courses.map(course => (
                                <tr key={course.id}>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {course.id}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {course.name}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {course.type}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                        <button
                                            type="button"
                                            className="text-blue-500 hover:underline"
                                            onClick={() => viewCourse(course.id)}
                                        >
                                            View
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Courses;
